"use client";

import {
  ArrowsRightLeftIcon,
  MusicalNoteIcon,
  ScissorsIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

import { BarOption } from "@/app/(marketing)/components/demo/bar/BarOption";
import { ArrowSplitIcon } from "@/icons/ArrowSplitIcon";
import { DemoBarOption, DemoOption } from "@/types/types";

const barOptions: DemoBarOption[] = [
  {
    name: "Convert vocals",
    mobileName: "Convert",
    value: "convert",
    icon: MusicalNoteIcon,
  },
  { name: "Train voice", mobileName: "Train", value: "train", icon: UsersIcon },
  {
    name: "Isolate vocals",
    mobileName: "Isolate",
    value: "isolate",
    icon: ScissorsIcon,
  },
  {
    name: "Mix voices",
    mobileName: "Mix",
    value: "mix",
    icon: ArrowsRightLeftIcon,
  },
  {
    name: "Make harmonies",
    mobileName: "Harmony",
    value: "harmony",
    icon: UserGroupIcon,
  },
  {
    name: "Stem splitter",
    mobileName: "Split",
    value: "stem",
    icon: ArrowSplitIcon,
  },
];

export function Bar({
  chosenOption,
  setChosenOption,
}: {
  chosenOption: DemoOption;
  setChosenOption: (option: DemoOption) => void;
}) {
  return (
    <ul className="mx-auto flex max-w-3xl">
      {barOptions.map((option) => (
        <BarOption
          key={option.value}
          option={option}
          chosen={chosenOption === option.value}
          setChosenOption={setChosenOption}
        />
      ))}
    </ul>
  );
}
